import InsertChartOutlinedIcon from "@mui/icons-material/InsertChartOutlined";
import AutoGraphOutlinedIcon from "@mui/icons-material/AutoGraphOutlined";
//import AddchartOutlinedIcon from "@mui/icons-material/AddchartOutlined";
import SolarPowerOutlinedIcon from "@mui/icons-material/SolarPowerOutlined";
import InsightsOutlinedIcon from "@mui/icons-material/InsightsOutlined";

const statistics = {
  id: "group-statistics",
  title: "Statistics",
  admin: false,
  type: "group",
  children: [
    {
      id: "statistics-total",
      type: "item",
      title: "발전량 보고서",
      url: "/statistics/report",
      icon: InsertChartOutlinedIcon,
      breadcrumbs: false,
    },
    // {
    //   id: "statistics-daily",
    //   title: "발전량(일보)",
    //   type: "item",
    //   url: "/statistics/daily",
    //   icon: InsertChartOutlinedIcon,
    //   breadcrumbs: false,
    // },

    // {
    //   id: "statistics-weekly",
    //   title: "발전량(주보)",
    //   type: "item",
    //   url: "/statistics/weekly",
    //   icon: InsertChartOutlinedIcon,
    //   breadcrumbs: false,
    // },

    // {
    //   id: "statistics-monthly",
    //   title: "발전량(월보)",
    //   type: "item",
    //   url: "/statistics/monthly",
    //   icon: InsertChartOutlinedIcon,
    //   breadcrumbs: false,
    // },

    // {
    //   id: "statistics-yearly",
    //   title: "발전량(연보)",
    //   type: "item",
    //   url: "/statistics/yearly",
    //   icon: InsertChartOutlinedIcon,
    //   breadcrumbs: false,
    // },

    {
      id: "statistics-term",
      title: "발전량(기간)",
      type: "item",
      url: "/statistics/term",
      icon: InsertChartOutlinedIcon,
      breadcrumbs: false,
    },

    {
      id: "statistics-days",
      title: "발전량(선택)",
      type: "item",
      url: "/statistics/days",
      icon: InsertChartOutlinedIcon,
      breadcrumbs: false,
    },

    {
      id: "statistics-times",
      title: "발전시간 관리",
      type: "item",
      url: "/statistics/times",
      icon: AutoGraphOutlinedIcon,
      breadcrumbs: true,
    },

    // {
    //   id: "statistics-predict",
    //   title: "발전량예측",
    //   type: "item",
    //   url: "/statistics/predict",
    //   icon: AddchartOutlinedIcon,
    //   breadcrumbs: false,
    // },

    {
      id: "statistics-weather",
      title: "기상관측정보",
      type: "item",
      url: "/statistics/weather",
      icon: SolarPowerOutlinedIcon,
      breadcrumbs: false,
    },

    {
      id: "monthly_report",
      title: "월간 보고서",
      type: "item",
      url: "/statistics/monthlyreport",
      icon: InsightsOutlinedIcon,
      breadcrumbs: false,
    },
  ],
};

export default statistics;
